const TIPOS = ['Noticia', 'Video', 'Audio']
const RE_HREF = /href\s*=\s*(["'])([\s\S]*?)\1/gi
const RE_CAMINHO = /(?:^|\/)(Noticia|Video|Audio)\/(\d+)(?:\/([^?#]*))?/i
const RE_ID_ANTIGO = /p_id(Noticia|Video|Audio)=(\d+)/i

function primeiroValor(valor) {
    return Array.isArray(valor) ? valor[0] : valor
}

function decodificarHtml(valor) {
    return String(valor || '')
        .replace(/&amp;/gi, '&')
        .replace(/&#38;/g, '&')
}

function decodificarSlug(valor) {
    if (!valor) return ''
    const bruto = String(valor).replace(/\+/g, ' ')
    try {
        return decodeURIComponent(bruto)
    } catch {
        return bruto
    }
}

export function slugConteudo(titulo) {
    if (!titulo) return ''
    return decodificarSlug(titulo)
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .toLowerCase()
        .replace(/\s+/g, '-')
        .replace(/[^a-z0-9-]/g, '')
        .replace(/-+/g, '-')
        .replace(/^-+|-+$/g, '')
}

export function rotaConteudo(tipo, id, slug) {
    const tipoRota = TIPOS.find(t => t.toLowerCase() === String(tipo || '').toLowerCase())
    const idLimpo = String(id || '').trim()
    if (!tipoRota || !idLimpo) return null
    const n = slugConteudo(slug)
    return n
        ? { name: tipoRota, params: { id: idLimpo, n } }
        : { name: tipoRota, params: { id: idLimpo } }
}

export function caminhoConteudo(tipo, id, slug) {
    const rota = rotaConteudo(tipo, id, slug)
    if (!rota) return ''
    const n = rota.params.n
    return n ? `/${rota.name}/${rota.params.id}/${n}` : `/${rota.name}/${rota.params.id}`
}

function buscarIdNaQuery(queryLower, tipo) {
    return queryLower[`p_id${tipo}`.toLowerCase()]
}

export function rotaConteudoDaQuery(query) {
    if (!query || typeof query !== 'object') return null
    const lower = {}
    Object.keys(query).forEach((chave) => {
        lower[chave.toLowerCase()] = primeiroValor(query[chave])
    })
    for (const tipo of TIPOS) {
        const id = buscarIdNaQuery(lower, tipo)
        if (id) return rotaConteudo(tipo, id, lower.n)
    }
    return null
}

function extrairConteudoAntigo(url) {
    const bruto = decodificarHtml(url)
    if (!bruto || !RE_ID_ANTIGO.test(bruto)) return null

    let search = ''
    try {
        const parsed = new URL(bruto, 'https://sollicita.com.br/')
        search = parsed.search || ''
    } catch {
        search = ''
    }

    if (!search || !RE_ID_ANTIGO.test(search)) {
        const inicio = bruto.search(RE_ID_ANTIGO)
        if (inicio >= 0) search = '?' + bruto.slice(inicio)
    }

    const params = new URLSearchParams(search.startsWith('?') ? search.slice(1) : search)
    const lower = {}
    params.forEach((valor, chave) => {
        lower[chave.toLowerCase()] = valor
    })

    for (const tipo of TIPOS) {
        const id = buscarIdNaQuery(lower, tipo)
        if (id) return rotaConteudo(tipo, id, lower.n)
    }

    const fallback = bruto.match(RE_ID_ANTIGO)
    if (!fallback) return null
    const nMatch = bruto.match(/[?&]n=([^&]*)/i)
    return rotaConteudo(fallback[1], fallback[2], nMatch ? nMatch[1] : '')
}

export function normalizarUrlConteudo(url) {
    if (url == null || url === '') return url
    const rota = extrairConteudoAntigo(url)
    if (!rota) return url
    return caminhoConteudo(rota.name, rota.params.id, rota.params.n)
}

export function normalizarLinksConteudoNoHtml(html) {
    if (!html || typeof html !== 'string') return html || ''
    return html.replace(RE_HREF, (full, quote, href) => {
        const novo = normalizarUrlConteudo(href)
        if (!novo || novo === href) return full
        return `href=${quote}${novo}${quote}`
    })
}

export function rotaConteudoDeHref(href) {
    if (!href) return null
    const antiga = extrairConteudoAntigo(href)
    if (antiga) return antiga

    let path = decodificarHtml(href)
    try {
        if (/^https?:\/\//i.test(path)) path = new URL(path).pathname
    } catch {
        return null
    }

    const match = String(path).match(RE_CAMINHO)
    if (!match) return null
    return rotaConteudo(match[1], match[2], match[3])
}

export function navegarLinkConteudo(evento, router) {
    if (!evento || !router) return false
    const ancora = evento.target && evento.target.closest && evento.target.closest('a[href]')
    if (!ancora) return false
    if (ancora.classList.contains('ver_anotacao')) return false

    const rota = rotaConteudoDeHref(ancora.getAttribute('href'))
    if (!rota) return false

    evento.preventDefault()
    if (ancora.getAttribute('target') === '_blank') {
        const resolved = router.resolve(rota)
        window.open(resolved.href, '_blank', 'noopener')
        return true
    }

    router.push(rota)
    return true
}

export function sincronizarSlugRota(router, route, titulo) {
    if (!router || !route || !TIPOS.includes(route.name)) return
    const slug = slugConteudo(titulo)
    if (!slug) return
    const atual = Array.isArray(route.params.n) ? route.params.n.join('/') : (route.params.n || '')
    if (atual === slug) return
    router.replace({
        name: route.name,
        params: { id: String(route.params.id), n: slug },
    })
}
